export default function isWindowUndocked() {
    let undocked = false;

    try {
        undocked = !!window.opener && window.opener.location.origin === window.location.origin;
    } catch {
        // if window.opener.location was a different origin, it throws, skip because we now know we should be in undocked mode
    }

    return undocked;
}
